import React from 'react';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import { useStyles } from './container-layout-styles';

export default function ContainerLayout({
  className,
  children,
}: React.PropsWithChildren<{ className?: string }>) {
  const classes = useStyles();

  return (
    <Grid container className={clsx(classes.layout, className)}>
      <Grid item xs={false} sm={1} />

      <Grid item xs={12} sm={10}>
        <Grid container>{children}</Grid>
      </Grid>

      <Grid item xs={false} sm={1} />
    </Grid>
  );
}
